import { render } from "./MobileAppList.vue?vue&type=template&id=52173eba"
import script from "./MobileAppList.vue?vue&type=script&lang=js"
export * from "./MobileAppList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__